import { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import Select from 'react-select';

import { editarContacto } from '../../actions/asesorias';

import { CustomValueContainer } from '../../components/react_select/ReactSelect';

const EditarContacto = ({ contacto, reestablecerContacto }) => {

    const dispatch =  useDispatch();

    const [contactoData, setContactoData] = useState({
        id_contacto: null, 
        id_asesoria: null, 
        tipo: null, 
        observaciones: null
    });

    const [tipoContactoData, setTipoContactoData] = useState(null);
    const tiposContactoFilter = [
        { value: 0, label: 'Correo'}, 
        { value: 1, label: 'Llamada'}, 
        { value: 2, label: 'WhatsApp'}, 
        { value: 3, label: 'Presencial'}
    ];

    const [contactoModal, setContactoModal] = useState(false);
    const [statusProcesar, setStatusProcesar] = useState(false);

    let styles_select = {
        menuPortal: base => ({ ...base, zIndex: 9999 }), 
        container: (provided, state) => ({
            ...provided, 
        }),
        control: (provided, state) => ({
            ...provided,
            paddingTop: '5px',
            paddingBottom: '5px',
        }),
        valueContainer: (provided, state) => ({
            ...provided,
            overflow: "visible", 
            marginTop: "10px"
        }),
        placeholder: (provided, state) => ({
            ...provided,
            position: "absolute",
            top: state.hasValue || state.selectProps.inputValue ? -15 : "0%",
            transition: "top 0.1s, font-size 0.1s",
            fontSize: (state.hasValue || state.selectProps.inputValue) && 13
        })
    };

    /* Agregar contacto */
    const handleSelectTipo = (option) => {
        setTipoContactoData(option);

        setContactoData({
            ...contactoData,
            tipo: option ? option.value : null
        });
    }

    const handleInputChange = ({ target }) => {
        setContactoData({
            ...contactoData,
            [target.name]: target.value
        });
    }

    const handleProcesar = async () => {
        await setStatusProcesar(true);

        await dispatch(editarContacto(contactoData));

        await handleCerrar(null);
        await setStatusProcesar(false);
    }

    const handleCerrar = () => {
        if(!statusProcesar){
            setContactoData({
                id_contacto: null, 
                id_asesoria: null, 
                tipo: null, 
                observaciones: null
            });

            reestablecerContacto(null);

            setContactoModal(false);
        }
    }

    useEffect(() => {
        if(contacto){            
            setContactoData({
                ...contactoData, 
                id_contacto: contacto.id_contacto, 
                id_asesoria: contacto.id_asesoria, 
                tipo: contacto.tipo, 
                observaciones: contacto.observaciones
            });

            let tipo_asignado = tiposContactoFilter.find( tipo => String(tipo.value) === String(contacto.tipo) );

            if(tipo_asignado){
                setTipoContactoData({value: tipo_asignado.value, label: tipo_asignado.label});
            }

            setContactoModal(true);
        }
    }, [contacto]);

    return (
        <Modal show={contactoModal} backdrop="static" centered onHide={() => handleCerrar()}>
            <Modal.Header closeButton>
                <Modal.Title>Editar contacto</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="col-md-12 form-group mb-3">
                    <div className="input-group h-100">
                        <Select
                            id="tipo"
                            name="tipo"
                            className="select-group"
                            classNamePrefix="react-select"
                            placeholder="Tipo de contacto"
                            isClearable={true}
                            options={tiposContactoFilter}
                            value={tipoContactoData}
                            onChange={(value) => handleSelectTipo(value)}
                            menuPortalTarget={document.body}
                            components={{ ValueContainer: CustomValueContainer }}
                            styles={{ ...styles_select }}
                        />
                    </div>
                </div>

                <div className="col-md-12 form-group mb-3">
                    <div className="input-group">
                        <div className="form-floating">
                            <textarea className="form-control textareCampo" placeholder="Observaciones" id="observaciones" name="observaciones" value={contactoData.observaciones} onChange={e => handleInputChange(e)}></textarea>
                            <label htmlFor="observaciones">Observaciones</label>
                        </div>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button type="button" className="btn btn-danger mr-3" onClick={() => handleCerrar()} disabled={ statusProcesar }><i className="fas fa-times fa-sm"></i> Cancelar</button>
                {
                    statusProcesar ?
                        <button type="button" className="btn btn-success" disabled><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Guardar</button>
                    :
                        <button type="button" className="btn btn-success" onClick={() => handleProcesar()}><i className="fas fa-check fa-sm"></i> Guardar</button>
                }
            </Modal.Footer>
        </Modal>
    )
}

export default EditarContacto;